import React, { useState, useEffect } from 'react'
import moment from 'moment-timezone'
import { currencyFormat } from '../../Product/common/components'

const InvoiceTerms = (props) => {
    const auctionData = props.auctionData
    const loaAuction = document.body.classList == 'LotsAuction'

    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'

    return (
        <div className="date-time-container">
            <div className="dates-time-wrapper">
                {!isVarifiedGfTheme ? (
                    <div className="loa-gray-box">
                        <p>
                            <strong>Pickup Location Is:</strong> {auctionData.address},{' '}
                            {auctionData.city}, {auctionData.state}
                        </p>
                    </div>
                ) : null}
                <div className="loa-gray-box">
                    <p>
                        <strong>Auction Rules:</strong>
                    </p>
                    {!isVarifiedGfTheme ? (
                        <p>
                            This is an ONSITE auction. All winning bidders must remove items
                            purchased within the stated load out times. Items that are not removed
                            from the facility, within the loadout time range, will be considered
                            forfeited. There are NO REFUNDS on forfeited items. Winning bidders will
                            be responsible for the removal of items purchased and are required to
                            bring their own help tools and transportation to remove items purchased.
                            All merchandise is sold &#34;ASIS&#34;. We do try our absolute best to
                            perform a basic functionality test on each item to prevent any type of
                            misrepresentation. There are no guarantees that any parts or accessories
                            are included with an item unless they are photographed in the auction.
                        </p>
                    ) : (
                        <p>
                            This is an online auction. All winning bidders{' '}
                            <i style={{ marginRight: '0px' }}>must</i> pick up their purchased items
                            within <b>3 business days</b> from the close of the auction. Items not
                            removed within this time frame will be considered abandoned and
                            forfeited without refund.
                            <br />
                            <b>Please note:</b>
                            <br />
                            No refunds will be issued for forfeited or abandoned items.
                            <br />
                            All items are sold &quot;AS IS&quot;. While we do our best to perform a
                            basic functionality check, we do not guarantee the presence or operation
                            of any parts, accessories, or components unless clearly shown in the
                            listing photos.
                            <br />
                            Winning bidders are responsible for bringing their own tools, help, and
                            transportation to safely remove their items from the premises.
                        </p>
                    )}
                    <p>
                        <strong>Returns Policy:</strong>
                    </p>
                    {!isVarifiedGfTheme ? (
                        <p>See auction for return specifics</p>
                    ) : (
                        <p>
                            Returns are accepted only for items not designated as Flash or Close Out
                            items. If the provided item is refused and remains at the designated
                            inspection area prior to exiting the premises, a refund will be issued.
                            Once an item leaves the premises, it is ineligible for return.
                        </p>
                    )}
                    {!isVarifiedGfTheme ? (
                        <>
                            {' '}
                            <p>
                                <strong>Location</strong>
                            </p>
                            <p>
                                {auctionData.local_pickup == 1 && auctionData.shipping == 1
                                    ? 'Local Pick-up and Shipping are available for this auction.'
                                    : auctionData.local_pickup == 1
                                    ? 'Local Pick-up is only avaialbe  for this auction.'
                                    : auctionData.shipping == 1
                                    ? 'Shipping is only avaialbe  for this auction.'
                                    : null}
                            </p>
                        </>
                    ) : (
                        <>
                            <p>
                                <strong>Pickup Location:</strong>
                            </p>
                            <p>
                                4645 Morse Centre Rd.
                                <br />
                                Columbus, OH 43229
                            </p>
                        </>
                    )}
                </div>
                <div className="loa-gray-box">
                    <p>
                        <strong>Buyers Premium:</strong> A non-refundable fee calculated as a
                        percentage of the winning bid, added on top of local taxes, covering service
                        and administrative costs.
                        {/* There will be {auctionData?.la_seller_id}%
                        Buyers Premium and{' '}
                        {currencyFormat(parseFloat(auctionData.lot_fee).toFixed(2))} lot fee
                        assessed on this auction.{' '} */}
                        {!isVarifiedGfTheme ? (
                            <>The Buyer Premium will be added to your final invoice.</>
                        ) : null}
                    </p>
                    <p>
                        <strong>Secure Transaction Fee:</strong>
                    </p>
                    <p>
                        This non-refundable fee is applied per winning lot to cover secure payment
                        processing, item verification, and dedicated customer support.
                    </p>
                    <p>
                        <strong>Sales Tax:</strong>
                    </p>
                    {!isVarifiedGfTheme ? (
                        <p>
                            Bidder will be subject to pay{' '}
                            {global.storeConfigration?.sales_tax?.value !== undefined
                                ? global.storeConfigration?.sales_tax?.value
                                : 8.5}
                            % for Sales Tax which automatically be added to your final invoice.
                            Sales Tax applies to both the item purchase and Buyer&apos;s Permium.
                        </p>
                    ) : (
                        <p>
                            All purchases are subject to an 8% sales tax on the full invoice upon
                            winning an item.
                        </p>
                    )}
                    <p>
                        <strong>Payment Collected:</strong>
                    </p>
                    <p>
                        Credit/Debit cards on file will automatically be charged within 4 hours
                        after the auction close time.
                    </p>
                    <p>
                        <strong>Payment Methods:</strong>
                    </p>
                    {!isVarifiedGfTheme ? <p>Credit/Debit Card, Cash</p> : <p>Credit/Debit Card</p>}
                    <p>
                        <strong>Non-Payment:</strong>
                    </p>
                    {!isVarifiedGfTheme ? (
                        <p>
                            If payment for items is not received within the load out time bidders
                            account will be blacklisted. A 25% fee on unpaid items will be assessed
                            if the bidder choose to reinstate the account. Any future accounts
                            created by a blacklisted bidder will be automatically removed.
                        </p>
                    ) : (
                        <p>
                            Failure to complete payment within 72 hours may result in the order
                            being declared abandoned, with a notation made on the buyer&apos;s
                            account. Subsequent defaults may lead to suspension from future
                            auctions.
                        </p>
                    )}
                </div>
                {!isVarifiedGfTheme ? (
                    <div className="loa-gray-box">
                        <p>
                            <strong>Load Out Times:</strong> We are open for walkins Monday Through
                            Saturday from 9:00AM to 6:00PM.
                        </p>
                        <p>
                            You can schedule pickups Monday Through Saturday from 9:00 AM to 4:30 PM
                        </p>
                        <p>
                            Please schedule pickups two hours in advance so we can have your order
                            ready on time.
                        </p>
                        <p>
                            <strong>Location:</strong> {auctionData.address}, {auctionData.city},{' '}
                            {auctionData.state}
                        </p>
                        <p>
                            <strong>
                                Items must be picked up by{' '}
                                {loaAuction ? (
                                    <>
                                        {moment(auctionData.date_closed)
                                            .tz(moment.tz.guess())
                                            .add(7, 'days')
                                            .format('MM/D/YYYY')}
                                    </>
                                ) : (
                                    <>
                                        {moment(auctionData.date_closed)
                                            .tz(moment.tz.guess())
                                            .add(7, 'days')
                                            .format('MMM Do YYYY, h:mm a z')}
                                    </>
                                )}
                            </strong>
                        </p>
                        <p>
                            <strong>Removal Assistance:</strong> Winning bidders will be responsible
                            for the pickup of items purchased and are required to bring their own
                            help, tools and transportation to remove items purchased.
                        </p>
                        <p>
                            <strong>Abandonment and Forfeit of items:</strong> If items is not
                            picked up within the started loadout time, the item will be considered
                            abandoned and forfeited. No refund will be given for abandoned,
                            forfeited items.
                        </p>
                        <p>
                            <strong>Picking Up with Unpaid Invoice:</strong> All invoices must be
                            paid in full at all locations before any items will be released.
                        </p>
                        <p>
                            <strong>
                                Returns must be received by{' '}
                                {loaAuction ? (
                                    <>
                                        {moment(auctionData.date_closed)
                                            .tz(moment.tz.guess())
                                            .add(7, 'days')
                                            .format('MM/D/YYYY')}
                                    </>
                                ) : (
                                    <>
                                        {moment(auctionData.date_closed)
                                            .tz(moment.tz.guess())
                                            .add(7, 'days')
                                            .format('MMM Do YYYY, h:mm a z')}
                                    </>
                                )}
                            </strong>
                        </p>
                    </div>
                ) : (
                    <div className="loa-gray-box">
                        <p>
                            <strong>Pickup Hours:</strong>
                        </p>
                        <p>Tuesday through Saturday: 12 PM - 7 PM</p>
                        {/* <p>Saturday: 10AM - 7PM</p> */}
                        <p>
                            <strong>Pickup & Removal Guidelines:</strong>
                        </p>
                        <p>
                            Winning bidders are fully responsible for picking up and removing their
                            purchased items. Please plan ahead by bringing your own help, tools, and
                            transportation to safely load and take your items home. Staff will not
                            be available to assist with loading.
                        </p>
                        <p>
                            <strong>Abandon Items:</strong>
                        </p>
                        <p>
                            Orders will be deemed abandoned if payment is not received within 72
                            hours post-auction closure or if the items are not collected within
                            three (3) business days without purchasing an extended pickup option. An
                            abandoned order will result in a $150 penalty fee and account suspension
                            until resolved.
                        </p>
                        <p>
                            <strong>Unpaid Invoices:</strong>
                        </p>
                        <p>
                            All invoices must be paid in full at all locations before any items will
                            be released.
                        </p>
                    </div>
                )}
                {/* <div className="loa-gray-box">
                    <p>
                        <strong>Buyer&apos;s Premium and Fees:</strong> There will be a{' '}
                        {auctionData.la_seller_id}% Buyers Premium and a{' '}
                        {currencyFormat(parseFloat(auctionData.lot_fee).toFixed(2))} lot fee
                        assessed on this auction.
                    </p>
                </div> */}
                {isVarifiedGfTheme ? (
                    <div className="loa-gray-box">
                        <p>
                            <strong>Customer Service:</strong>
                        </p>
                        <p>Retail Rush</p>
                        <p>support@retailrush.com</p>
                    </div>
                ) : (
                    <div className="loa-gray-box">
                        <p>
                            <strong>Customer Service:</strong>
                        </p>
                        <p>Lots of Auctions</p>
                        <p>(800) 830-9381</p>
                        <p>customerservice@lotsofauctions.com</p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default InvoiceTerms
